/* Scroll reveal */
const io=new IntersectionObserver((es)=>{es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.12});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

/* HLS playback for xBloom .m3u8 streams (graceful: native on Safari, hls.js elsewhere) */
(function(){
  const vids=[...document.querySelectorAll('video source[type="application/x-mpegURL"]')];
  if(!vids.length)return;
  const canNative=document.createElement('video').canPlayType('application/vnd.apple.mpegurl');
  function attach(){
    vids.forEach(s=>{
      const v=s.parentElement,url=s.src;
      if(canNative){v.src=url;v.load();v.play().catch(()=>{});}
      else if(window.Hls&&Hls.isSupported()){const h=new Hls();h.loadSource(url);h.attachMedia(v);v.play().catch(()=>{});}
    });
  }
  if(canNative){attach();}
  else{const sc=document.createElement('script');sc.src='https://cdn.jsdelivr.net/npm/hls.js@1';sc.onload=attach;document.head.appendChild(sc);}
})();
